import React from "react";
import styled from "styled-components";
import { withI18n } from "react-i18next";
// @ts-ignore
import { CWBModal, CWBLoadingCrest, getSessionDataFromAuthToken } from "cwb-react";
import MultiSelect from "react-multi-select-component";
import { Button, ButtonGroup } from "../Common";
import { IKioskSessionRoles } from "../../interfaces/IKioskSessionRoles";
import { IMultiSelectOption } from "../../interfaces/IMultiSelectOption";
import Uppy from "@uppy/core";
import Tus from "@uppy/tus";
import "@uppy/core/dist/style.css";
import "@uppy/file-input/dist/style.css";
//import ProgressBar from "@uppy/progress-bar";
import "@uppy/progress-bar/dist/style.css";
import { IMedia } from "../../interfaces/IMedia";
import { iRootState } from "../../store";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import VideoDirection from "../Kiosk/Directions/VideoDirection";
import { IVideoDirection } from "../../interfaces/IVideoDirections";
import { IKeyValueVideoDirection } from "../../interfaces/IKeyValueVideoDirection";
import PlayerModal from "./PlayerModal";
import imageSrc from "../../images/icon-cwb-logo-grey.svg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Theme/custom-toast.css";
import { ISentVideoDirection } from "../../shared/dto/IKioskDto";
import { IKioskSessionAuditionsDto } from "../../interfaces/IKioskSessionAuditionsDto";

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  buttons?: any;
  show: boolean;
  session: IKioskSessionAuditionsDto;
  pastAudition: boolean;
  onClose: (e: any, showToast?: boolean, aspToast?: string) => void;
  onMultiSelectChange: (lst: IMultiSelectOption[]) => void;
  t: any;
  isUploading?: boolean;
  scheduleId: any;
  isParentLoading: boolean;
}

class VideoDirectionModal extends React.Component<IProps, any> {
  private uppy: any;

  state = {
    hasUploads: false,
    uploadedRoles: [] as IKioskSessionRoles[],
    showVideoPlayer: false,
    uploadedMediaIds: [] as any[],
    medias: [] as IMedia[],
    rolesSelected: [] as IKioskSessionRoles[],
    videoUrl: "",
    tmpPolaroid: [] as {
      roleId: number;
      polaroid: string;
    }[],
    isLoading: false,
    deleteDirectionRadio: "1",
  };

  constructor(props: any) {
    super(props);

    this.uppy = Uppy({
      meta: {},
      restrictions: {
        maxFileSize: 2147483648,
        minNumberOfFiles: 1,
        maxNumberOfFiles: 100, // 100 is just a random large number...
        allowedFileTypes: ["video/*"],
      },
      autoProceed: true,
      debug: false,
    });

    // TODO: Temp testing upload endpoint
    const decoded = getSessionDataFromAuthToken(localStorage.getItem("CWBAPI_TOKEN"));
    this.uppy.use(Tus, {
      endpoint: process.env.TUS,
      headers: {
        WebSessionKey: decoded.WebSessionKey
      },
      chunkSize: 3000000, //3mb
      withCredentials: true,
      limit: 1,
      autoRetry: true,
      retryDelays: [1000, 3000, 5000]
    });

    this.uppy.on("file-added", (file: any) => {
      // First roles or only 1 role selected
      let uploadedRoles = [...this.state.uploadedRoles];
      let copyRolesSelected = [...this.state.rolesSelected];
      let role = copyRolesSelected.pop(); // random for now
      this.uppy.setFileMeta(file.id, {
        name: role.roleName,
        // fileType: file.type, we don't need fileType
        filename: file.name, // case sensitive
        clientId: "33633",
        title: role.roleName
      });
      uploadedRoles.push(role);
      this.setState({ uploadedRoles });
      this.generatePolaroid(file, this.state.rolesSelected);
      this.setState({ isLoading: true });
    });

    let roleVideoDirectionQueue: IKioskSessionRoles[] = [];
    this.uppy.on("upload", (data: any) => {
      // data object consists of `id` with upload ID and `fileIDs` array
      // with file IDs in current upload
      let uploadedRoles = [...this.state.uploadedRoles];
      let copyRolesSelected = [...this.state.rolesSelected];

      let uploadedRolesNotInSelected = copyRolesSelected.filter(
        (ar) => !uploadedRoles.find((rm) => rm.roleId === ar.roleId)
      );

      uploadedRolesNotInSelected.forEach(element => {
        uploadedRoles.push(element);
        roleVideoDirectionQueue.push(element);
      });

      this.setState({ uploadedRoles });
    });

    this.uppy.on("upload-error", (file: any, error: any, response: any) => {
      toast.error("The video upload failed, please check your internet connection and try again or contact our support.", {
        position: "top-right",
        autoClose: false
      });
      this.setState({ isLoading: false });
      this.uppy.reset();
      roleVideoDirectionQueue = [];
    });

    this.uppy.on("complete", async (result: any) => {
      this.uppy.reset();
      const copyUploadRoleQueue = [...roleVideoDirectionQueue];
      roleVideoDirectionQueue = [];

      if (result && result.failed && result.failed.length > 0) {
        console.log(result.failed[0].error);
        return;
      }

      const url = result.successful[0].uploadURL;

      // TODO:
      var response = await fetch(url, {
        method: "GET",
        credentials: "include",
      });

      const mediaObject = await response.json();
      var mediaId = mediaObject.mediaId; //121669;

      let allVideoDirections: IVideoDirection[] = [];
      // post create video direciton record
      let videoDirection: IVideoDirection = {
        videoId: mediaId,
        breakdownId: this.props.session.bdId,
        bDType: this.props.session.bdType, // TODO: was null
        scheduleId: this.props.scheduleId,
        roleId: this.getRoleId(result),
      };

      allVideoDirections.push(videoDirection);
      let added: [number] = [this.getRoleId(result)]

      for (let i = 0; i < copyUploadRoleQueue.length; i++) {
        const element = copyUploadRoleQueue[i];
        if (added.find(a => a === element.roleId)) {
          continue;
        }
        allVideoDirections.push(
          {
            videoId: mediaId,
            breakdownId: this.props.session.bdId,
            bDType: this.props.session.bdType,
            scheduleId: this.props.scheduleId,
            roleId: element.roleId
          }
        )
        added.push(element.roleId);
      }

      await this.props.addVideoDirections(allVideoDirections);
      // mediaId get media details
      const { uploadedMediaIds } = this.state;
      var mediaIds = [...uploadedMediaIds];
      mediaIds.push(mediaId);
      this.setState({ uploadedMediaIds: mediaIds });
      await this.loadDirectionMedias();
      this.setState({ isLoading: false });


    });
  }

  getRoleId = (result: any): number => {
    const { uploadedRoles } = this.state;
    const role = uploadedRoles.find(
      (x) => x.roleName === result.successful[0].meta.name
    );
    if (!role) return 0; // TODO
    return role.roleId;
  };

  async componentDidMount() {
    this.setState({ isLoading: true });
    await this.loadData();
    this.setState({
      tmpPolaroid: this.props.videoDirections.map(vd => {
        const targetMedia = this.props.medias.find(m => {
          return m.mediaId === vd.videoId
        });
        return {
          roleId: vd.roleId,
          polaroid: targetMedia.polaroid ? targetMedia.polaroid : null
        };
      })
    });

    this.setState({ isLoading: false });
  }

  static getDerivedStateFromProps(props: any, state: any) {
    if (props.scheduleId !== state.scheduleId) {
      return {
        scheduleId: props.scheduleId,
      };
    }
    return null;
  }

  loadData = async () => {
    if (this.props.scheduleId && this.props.scheduleId > 0) {
      await this.loadDirectionMedias();
      await this.props.getKioskSessionRoles(this.props.scheduleId);
    }
  };

  loadDirectionMedias = async () => {
    await this.props.getVideoDirections(this.props.scheduleId);

    if (this.props.videoDirections && this.props.videoDirections.length > 0) {
      const mediaIds = this.props.videoDirections
        .map((x) => x.videoId)
        .filter((value, index, self) => self.indexOf(value) === index)
        .join(",");
      await this.props.getMultipleMedia(mediaIds);
      this.setState({ medias: this.props.medias });
    }
  };

  loadMedias = async () => {
    if (this.props.videoDirections && this.props.videoDirections.length > 0) {
      const mediaIds = this.props.videoDirections
        .map((x) => x.videoId)
        .filter((value, index, self) => self.indexOf(value) === index)
        .join(",");
      await this.props.getMultipleMedia(mediaIds);
    } else {
      this.props.setMedias([] as IMedia[]);
    }
  };

  setSelectedRoles = () => {
    if (
      this.props.videoDirections &&
      this.props.videoDirections.length > 0 &&
      this.props.sessionRoles &&
      this.props.sessionRoles.length > 0
    ) {
      const rolesSelected = this.props.sessionRoles.filter((r) =>
        this.props.videoDirections.find((vd) => vd.roleId === r.roleId)
      );
      this.setState({ rolesSelected });
    }
  };

  componentWillUnmount() {
    // As per Uppy doc
    this.uppy.close();
    this.props.setMedias([] as IMedia[]);
  }

  onToggleVideoPlayer = (): any => {
    this.setState((prevState: any) => ({
      showVideoPlayer: !prevState.showVideoPlayer,
    }));
  };

  onClickPlayVideo = (url: string): any => {
    if (!url || !url.length) {
      // TODO: translation
      toast.info("The video is uploaded but is still encoding.", {
        position: "top-right"
      });
      return;
    }

    this.setState((prevState: any) => ({
      showVideoPlayer: !prevState.showVideoPlayer,
      videoUrl: url,
    }));
  };

  onChangeFile = (event: any) => {
    const files = Array.from(event.target.files);
    const file: any = files[0]; // only allow one file
    try {
      this.uppy.addFile({
        source: "file input",
        name: file.name,
        // type: file.type, we don't need fileType
        data: file,
      });
      this.setState({ hasUploads: true });
    } catch (err) {
      if (err.isRestriction) {
        // handle restrictions
        console.log("Restriction error:", err);
      } else {
        // handle other errors
        console.error(err);
      }
    }
  };

  getMediaName = (media: IMedia) => {
    const { videoDirections, sessionRoles } = this.props;

    if (
      !videoDirections ||
      videoDirections.length === 0 ||
      !sessionRoles ||
      sessionRoles.length === 0
    )
      return media.description;

    const vd = videoDirections.find((x) => x.videoId === media.mediaId);
    if (!vd) return media.description;

    const role = sessionRoles.find((x) => x.roleId === vd.roleId);
    if (!role) return media.description;

    return role.roleName;
  };

  getVideoDirectionId = (media: IMedia) => {
    const { videoDirections } = this.props;

    if (!videoDirections || videoDirections.length === 0) return 0;

    const vd = videoDirections.find((x) => x.videoId === media.mediaId);
    if (!vd) return 0;

    return vd.videoDirectionId;
  };

  onMultiSelectChange = (lstOptionsSelected: IMultiSelectOption[]) => {
    let rolesSelected = lstOptionsSelected.map((x: IMultiSelectOption) => {
      return {
        breakdownId: this.props.session.bdId,
        roleId: x.value && parseInt(x.value),
        roleName: x.label,
        scheduleId: this.props.scheduleId,
      } as IKioskSessionRoles;
    });
    this.setState({ rolesSelected });
  };

  onDeleteVideoDirection = async (videoDirectionId: number) => {
    if (!videoDirectionId) return;
    const scheduleId = this.props.scheduleId;
    const targetVD = this.props.videoDirections.find(vd => {
      return vd.videoDirectionId === videoDirectionId;
    });
    await this.props
      .deleteVideoDirection({ videoDirectionId, scheduleId })
      .then(async () => {
        await this.props
          .getVideoDirections(this.props.scheduleId)
          .then(async () => {
            await this.loadMedias();
            this.setState({
              medias: this.props.medias,
              tmpPolaroid: this.state.tmpPolaroid.filter(tp => {
                return tp.roleId === targetVD.roleId;
              })
            });
          });
      });
  };

  getAvailableRoles = () => {
    let bdType = this.props.session.bdType;
    if (!this.props.sessionRoles) return [] as IMultiSelectOption[];
    if (!this.props.videoDirections)
      return this.props.sessionRoles.map((x: IKioskSessionRoles) => {
        return {
          label: (bdType === 2 && x.spotName) ? `${x.spotName}/${x.roleName}` : x.roleName,
          value: x.roleId.toString(),
        } as IMultiSelectOption;
      });

    // filter out saved video direction roles
    let rolesNotVideoDirection = this.props.sessionRoles.filter(
      (r) => !this.props.videoDirections.find((vd) => vd.roleId === r.roleId)
    );

    return rolesNotVideoDirection.map((x: IKioskSessionRoles) => {
      return {
        label: (bdType === 2 && x.spotName) ? `${x.spotName}/${x.roleName}` : x.roleName,
        value: x.roleId.toString(),
      } as IMultiSelectOption;
    });
  };

  getSelectedRoles = () => {
    let ddlRolesSelected = [] as IMultiSelectOption[];

    const { rolesSelected } = this.state;

    if (
      !rolesSelected ||
      rolesSelected.length === 0 ||
      !this.props.sessionRoles ||
      this.props.sessionRoles.length === 0
    )
      return ddlRolesSelected;

    let availableRoles = this.props.sessionRoles;
    if (this.props.videoDirections)
      availableRoles = this.props.sessionRoles.filter(
        (r) => !this.props.videoDirections.find((vd) => vd.roleId === r.roleId)
      );

    // roleSelected in sessionRoles
    ddlRolesSelected = rolesSelected
      .filter((r) => availableRoles.find((s) => s.roleId === r.roleId))
      .map((role) => {
        return {
          label: role.roleName,
          value: role.roleId.toString(),
        } as IMultiSelectOption;
      });
    return ddlRolesSelected;
  };

  onCloseDeletePending = async (e: any) => {
    for (const m of this.props.medias) {
      if (
        this.props.videoDirections &&
        this.state.uploadedMediaIds &&
        this.state.uploadedMediaIds.includes(m.mediaId)
      ) {
        const vd = this.props.videoDirections.find(
          (x) => x.videoId === m.mediaId
        );
        if (vd) {
          await this.props.deleteVideoDirection({
            videoDirectionId: vd.videoDirectionId,
            scheduleId: this.props.scheduleId,
          });
        }
      }
    }
    this.props.onClose(e);
  };

  onSaveAndClose = (e: any) => {
    const { uploadedMediaIds } = this.state;

    // TODO: temp solution simply update redux -
    // later have backend pull all sent with sessions instead
    if (uploadedMediaIds && uploadedMediaIds.length > 0) {
      let o: ISentVideoDirection = {
        scheduleId: this.props.scheduleId,
        hasSentAll: false,
      };
      this.props.setSentAllVideoDirection(o);
    }

    const displayToast =
      this.props.session &&
      this.props.session.auditionsDetails &&
      this.props.session.auditionsDetails.length > 0;

    this.props.onClose(e, displayToast, "save");
  };

  onSaveAndSend = async (e: any) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    const {
      t,
      scheduleId,
      sendVideoDirections,
      setShowFailedEmailModal
    } = this.props;

    const success = await sendVideoDirections(scheduleId);
    if (success) {
        toast.success(t("Video Directions sent successfully"), {
          position: "top-right"
        });
    } else if (success === false) {
      toast.error((
        <span>
          {t("Some attendees did not receive the Video Directions.")}
          &nbsp;
          <LinkButton onClick={() => setShowFailedEmailModal(true)}>
            {t("view details")}
          </LinkButton>
        </span>
      ), {
        position: "top-right",
        autoClose: false
      });
    }

    this.setState({ isLoading: false });
    this.props.onClose(e, true, "sent");
  };

  generatePolaroid = (file: any, selectedRoles: any) => {
    const self = this;
    let fileReader = new FileReader();
    fileReader.onload = function () {
      let blob = new Blob([fileReader.result], { type: file.type });
      let url = URL.createObjectURL(blob);
      let video = document.createElement("video");
      let timeupdate = function () {
        if (snapImage()) {
          video.removeEventListener("timeupdate", timeupdate);
          video.pause();
        }
      };
      video.addEventListener("loadeddata", function () {
        if (snapImage()) {
          video.removeEventListener("timeupdate", timeupdate);
        }
      });
      let snapImage = function () {
        let canvas = document.createElement("canvas");
        canvas.width = 170; //video.videoWidth; // TODO:
        canvas.height = 126;
        canvas
          .getContext("2d")
          .drawImage(video, 0, 0, canvas.width, canvas.height);
        let image = canvas.toDataURL();
        self.setState({
          tmpPolaroid: [
            ...self.state.tmpPolaroid,
            ...selectedRoles.map((r: any) => {
              return {
                roleId: r.roleId,
                polaroid: image
              };
            })
          ]
        });
        URL.revokeObjectURL(url);
        return true;
      };
      video.addEventListener("timeupdate", timeupdate);
      video.preload = "metadata";
      video.src = url;
      video.muted = true;
      video.play();
    };
    fileReader.readAsArrayBuffer(file.data);
  };

  getPolaroid = (media: IMedia, roleId?: number) => {
    if (media && media.polaroid) return media.polaroid;

    const p = this.state.tmpPolaroid.find(tp => {
      return tp.roleId === roleId;
    });

    if (!p) return null;
    return p.polaroid;
  };

  getMediaUrl = (m: IMedia) => {
    return m && m.sources && m.sources[0] ? m.sources[0].url : null;
  };

  onDeleteDirectionRadioChange = (e: any) => {
    let deleteDirectionRadio = this.state.deleteDirectionRadio;
    deleteDirectionRadio = e.target.value;
    this.setState({ deleteDirectionRadio });
  };

  render() {
    const {
      show,
      session,
      t,
      pastAudition,
      onClose,
      medias,
      isParentLoading
    } = this.props;

    let bdType = session.bdType;

    let { videoDirections } = this.props;

    const { isLoading, uploadedMediaIds } = this.state;

    let ddlRoles = this.getAvailableRoles();

    let ddlRolesSelected = this.getSelectedRoles();

    const modalTitle =
      session && session.projectName
        ? `${session.projectName} ${t(`Directions`)}`
        : "";

    videoDirections = videoDirections ? videoDirections.map(vd => {
      const role = this.props.sessionRoles.find(r => {
        return r.roleId === vd.roleId;
      });
      return {
        ...vd,
        roleName: role && role.roleName
      };
    }) : [];

    return (
      <>
        <PlayerModal
          open={this.state.showVideoPlayer}
          toggleModal={this.onToggleVideoPlayer}
          url={this.state.videoUrl}
        />
        <StyledModal
          className={`cwb-modal`}
          title={modalTitle}
          body={""}
          hideModal={onClose}
          isOpen={show}
          backdrop="static"
        >
          {isParentLoading ? (
            <CWBLoadingCrest customLogoSrc={imageSrc} />
          ) : (
              <div>
                <section>
                  {!pastAudition && (
                    <StyledText>
                      {t("To Add Directions select the role from the dropdown and attach the video. You can edit the directions at any time by removing the attached video and adding a new one.")}
                    </StyledText>
                  )}
                  <form>
                    {!pastAudition && (
                      <div
                        className="form-group"
                        style={{ marginBottom: "20px" }}
                      >
                        {session &&
                          session.auditionsDetails &&
                          session.auditionsDetails.length === 0 && (
                            <>
                              <StyledTitle>
                                {t(
                                  "*** You must add auditions before adding video directions"
                                )}
                              </StyledTitle>
                            </>
                          )}
                        {session &&
                          session.auditionsDetails &&
                          session.auditionsDetails.length > 0 && (
                            <>
                              <StyledTitle>{t("Add Directions")}</StyledTitle>
                              <label>{bdType === 2? t("Select Spot/Role") : t("Select Role")}</label>
                              <div className="form-inline">
                                {ddlRoles && (
                                  <MultiSelect
                                    options={ddlRoles}
                                    value={ddlRolesSelected}
                                    onChange={(o: any) =>
                                      this.onMultiSelectChange(o)
                                    }
                                    labelledBy={"Select"}
                                    className="multi-ddl-directions"
                                    hasSelectAll={false}
                                    overrideStrings={{
                                      allItemsAreSelected: t("All items are selected."),
                                      search: t("Search")
                                    }}
                                  />
                                )}
                                <StyledButton
                                  disabled={
                                    !ddlRoles ||
                                    ddlRoles.length === 0 ||
                                    !ddlRolesSelected ||
                                    ddlRolesSelected.length === 0
                                  }
                                  type="button"
                                >
                                  {t("Attach Directions")}
                                  <StyledInput
                                    onChange={(e) => this.onChangeFile(e)}
                                    accept="video/*"
                                    type="file"
                                    name="file"
                                    multiple={false}
                                    disabled={
                                      !ddlRoles ||
                                      ddlRoles.length === 0 ||
                                      !ddlRolesSelected ||
                                      ddlRolesSelected.length === 0
                                    }
                                  />
                                </StyledButton>
                              </div>
                            </>
                          )}
                      </div>
                    )}
                    {/* {this.uppy && <ProgressBar uppy={this.uppy} />} */}

                    <div className="form-group">
                      <StyledTitle>{t("Attached Directions")}</StyledTitle>
                      {this.state.isLoading && (
                        <div style={{ marginTop: "-30px", marginBottom: "25px" }}>
                          <CWBLoadingCrest customLogoSrc={imageSrc} />
                        </div>
                      )}
                      {!this.state.isLoading && (!medias ||
                        (medias.length === 0) ? (
                          <>
                            <p style={{ marginBottom: "50px" }}>
                              {t("You have not attached any video directions.")}
                            </p>
                          </>
                        ) : null)}
                      {medias && medias.length && videoDirections && videoDirections.length
                        ?  (videoDirections.map((v: any, idx: number) => {
                          const m:IMedia = medias && medias.find((media) => v.videoId === media.mediaId);
                          if (!m)
                            return null;
                          const url = m && this.getMediaUrl(m);
                          const polaroid = m && this.getPolaroid(m, v.roleId);
                          if (!polaroid || !polaroid.length) {
                            if (!uploadedMediaIds.includes(m.mediaId)) {
                              uploadedMediaIds.push(m.mediaId)
                            }
                          }
                          return (
                            <VideoDirection
                              key={idx}
                              url={url}
                              fileName={v.roleName || ''}
                              polaroid={polaroid}
                              isPending={uploadedMediaIds.includes(m.mediaId)}
                              date={m.createdOn}
                              open={this.state.showVideoPlayer}
                              onClickPlayVideo={this.onClickPlayVideo}
                              videoDirectionId={v.videoDirectionId}
                              onDeleteVideoDirection={this.onDeleteVideoDirection}
                              pastAudition={pastAudition}
                            />
                          );
                        })
                        )
                        : null}
                    </div>
                    <div className="form-group" style={{ marginTop: "30px" }}>
                      {medias && medias.length ? (
                        <RadioWrapper>
                          <span>Delete directions from database after:</span>
                          <RadioInput
                            type="radio"
                            id="1-a"
                            name={"deleteVideo"}
                            onChange={this.onDeleteDirectionRadioChange}
                            disabled={false}
                            value={1}
                            checked={this.state.deleteDirectionRadio === "1"}
                          />
                          <RadioStyledInput />
                          <RadioLabelTitle htmlFor="1-a">
                            {t("30 Days")}
                          </RadioLabelTitle>
                          <RadioInput
                            type="radio"
                            id="2-a"
                            name={"deleteVideo"}
                            onChange={this.onDeleteDirectionRadioChange}
                            disabled={false}
                            value={2}
                            checked={this.state.deleteDirectionRadio === "2"}
                          />
                          <RadioStyledInput />
                          <RadioLabelTitle htmlFor="2-a">
                            {t("60 days")}
                          </RadioLabelTitle>
                          <RadioInput
                            type="radio"
                            id="3-a"
                            name={"deleteVideo"}
                            onChange={this.onDeleteDirectionRadioChange}
                            disabled={false}
                            value={3}
                            checked={this.state.deleteDirectionRadio === "3"}
                          />
                          <RadioStyledInput />
                          <RadioLabelTitle htmlFor="3-a">
                            {t("90 days")}
                          </RadioLabelTitle>
                        </RadioWrapper>
                      ) : null}
                    </div>
                    {!pastAudition && (
                      <div className="form-group" style={{ marginTop: "30px" }}>
                        <ButtonGroup>
                          <Button
                            disabled={isLoading || !medias || !medias.length}
                            onClick={this.onSaveAndSend}
                          >
                            {t("Save & Send")}
                          </Button>
                          <Button
                            variant="secondary"
                            onClick={this.onSaveAndClose}
                          >
                            {t("Save & Close")}
                          </Button>
                        </ButtonGroup>
                        <StyledPNote>
                          {t("Note: Directions will be sent via email to all actors/agents with the corresponding role. Any updates will be sent to the actor.")}
                        </StyledPNote>
                      </div>
                    )}
                  </form>
                </section>
              </div>
            )}
        </StyledModal>
      </>
    );
  }
}

interface StateProps {
  medias: IMedia[];
  videoDirections: IVideoDirection[];
  sessionRoles: IKioskSessionRoles[];
  dictVideoDirection: IKeyValueVideoDirection;
}

function mapStateToProps(state: iRootState, ownProps: any): StateProps {
  let videoDirections = [] as IVideoDirection[];
  if (state.kiosk.dictVideoDirection) {
    videoDirections = state.kiosk.dictVideoDirection[ownProps.scheduleId];
  }
  return {
    //sessionInfoSheet: sessionInfoSheet,
    videoDirections,
    medias: state.kiosk.medias,
    sessionRoles: state.kiosk.sessionRoles,
    dictVideoDirection: state.kiosk.dictVideoDirection,
  };
}

interface DispatchProps {
  getMultipleMedia: (ids: string) => void;
  getVideoDirections: (id: any) => Promise<void>;
  setMedias: (medias: IMedia[]) => void;
  addVideoDirections: (videoDirections: IVideoDirection[]) => void;
  getKioskSessionRoles: (id: number) => Promise<void>;
  deleteVideoDirection: ({
    videoDirectionId,
    scheduleId,
  }: any) => Promise<void>;
  sendVideoDirections: (scheduleId: any) => boolean;
  setSentAllVideoDirection: (
    sentAllVideoDirection: ISentVideoDirection
  ) => void;
  setShowFailedEmailModal: (show: boolean) => any;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    getMultipleMedia: dispatch.kiosk.getMultipleMedia,
    getVideoDirections: dispatch.kiosk.getVideoDirections,
    setMedias: dispatch.kiosk.setMedias,
    addVideoDirections: dispatch.kiosk.addVideoDirections,
    getKioskSessionRoles: dispatch.kiosk.getKioskSessionRoles,
    deleteVideoDirection: dispatch.kiosk.deleteVideoDirection,
    sendVideoDirections: dispatch.kiosk.sendVideoDirections,
    setSentAllVideoDirection: dispatch.kiosk.setSentAllVideoDirection,
    setShowFailedEmailModal: dispatch.kiosk.setShowFailedEmailModal
  };
}

export default withI18n()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(VideoDirectionModal))
);

const StyledModal = styled(CWBModal)`
  width: 100%;
  max-width: 600px !important;
  margin: 0 auto;

  &.create-role-modal {
    max-width: 450px;

    .modal-buttons {
      justify-content: space-around !important;
    }
  }

  .modal-header: {
    justify-content: left !important;
  }

  .modal-dropdown {
    min-width: 200px;
    max-width: 200px;
    .cwb-dropdown__menu {
      .cwb-dropdown__option {
        min-width: 185px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }

  .modal-content {
    width: 100%;
    padding: 20px 20px 0px 20px !important;
  }

  .modal-body {
    padding-bottom: 16px;
    text-align: left !important;
    padding: 0px 0px 0px 0px !important;
  }

  .modal-buttons {
    justify-content: space-between !important;
  }

  .close-modal {
    right: 20px;

    &:before {
      color: #8395a7;
      font-size: 16px;
    }
  }

  .cwb-dropdown-wrapper {
    .cwb-dropdown__menu-list {
      text-align: left;
    }
  }
`;

const StyledText = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;

  color: #364866;
`;

const StyledTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;

  color: #364866;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const StyledButton = styled(Button)`
  height: 38px;
  position: relative;
`;

const StyledInput = styled.input`
  width: 100%;
  height: 100%;
  position: absolute;
  font-size: 100px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;

  &:disabled { cursor: not-allowed; }
`;

const RadioWrapper = styled.div`
  display: inline-block;
  position: relative;
  line-height: ${(props) => props.theme.formField["font-size"]};

  .fake-radio-button {
    fill: white;
  }

  input:disabled:checked + div svg .styled-radio-button-center {
    fill: ${(props) => props.theme.formField.disabled["color"]};
  }

  .styled-radio-button-outline {
    stroke: ${(props) => props.theme.formField.outline};
  }

  input:not(:disabled):hover + div svg .styled-radio-button-outline,
  input:not(:disabled):checked + div svg .styled-radio-button-outline {
    stroke: ${(props) => props.theme.lightBlue};
  }

  input:checked + div svg .styled-radio-button-center {
    fill: ${(props) => props.theme.lightBlue};
  }

  input:focus + div svg {
    box-shadow: 0 0 6px rgba(25, 99, 246, 0.6);
    border-radius: 100%;
  }

  input:disabled + div,
  input:disabled,
  input:disabled ~ label {
    cursor: not-allowed;
  }

  input:disabled + div svg .styled-radio-button-outline {
    stroke: ${(props) => props.theme.formField.disabled["color"]};
  }

  border-radius: 4px;
  padding: 2px 0px;
  width: 100%;
`;

const RadioInput = styled.input`
  cursor: pointer;
  opacity: 0;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 15px;
  height: 15px;
  z-index: 100;
  padding: 0px;
  margin: 0px;
  vertical-align: middle;
`;

const RadioLabelTitle = styled.label`
  color: ${(p) => p.theme.formField["color"]};
  font-family: ${(props) => props.theme["font-family"]};
  font-size: ${(props) => props.theme.formField["font-size"]};
  margin-left: 25px;
  margin-top: 10px;
  vertical-align: middle;
  z-index: 2;
  &:hover {
    cursor: pointer;
  }
`;

const RadioStyledInput = () => (
  <StyledInputWrapper
    dangerouslySetInnerHTML={{
      __html: `<svg width="15" height="15" viewBox="0 0 15 15" style="overflow: visible">
    <g stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-69.000000, -293.000000)">
        <g transform="translate(69.000000, 268.000000)">
          <g transform="translate(0.000000, 25.000000)">
            <circle fill="#FFFFFF" cx="7.5" cy="7.5" r="7.5"></circle>
            <path class="styled-radio-button-outline" d="M7.5,15 C11.6421356,15 15,11.6421356 15,
              7.5 C15,3.35786438 11.6421356,0 7.5,0 C3.35786438,0 0,3.35786438 0,7.5 C0,
              11.6421356 3.35786438,15 7.5,15 Z M7.5,14 C11.0898509,14 14,11.0898509 14,
              7.5 C14,3.91014913 11.0898509,1 7.5,1 C3.91014913,1 1,3.91014913 1,7.5 C1,
              11.0898509 3.91014913,14 7.5,14 Z" fill="#AFAFAF"></path>
            <circle fill="white" cx="7.5" cy="7.5" r="3.5" class="styled-radio-button-center"></circle>
          </g>
        </g>
      </g>
    </g>
  </svg>`,
    }}
  />
);

const StyledInputWrapper = styled.div`
  z-index: 1;
  display: inline;
  margin-left: 0;
  left: 15px;
  cursor: pointer;
  position: relative;
`;

const StyledPNote = styled.p`
  margin-top: 20px;
  font-size: 12px;
`;

const LinkButton = styled.button`
  color: #0F9BF0;
  padding: 0;
  background-color: #FFF;
  border: none;
  text-decoration: underline;
`;
